module.exports = __webpack_public_path__ + "static/img/a101.a96492c8.png";